import { getRawDataFromToothMatrixRaw } from "../convert/rawConver";

export const getToothMatrixDOFromFilePath = async (filePath, fileData) => {
  const regex = /.*_STAGE_(\d+).*__(LOWER|UPPER)__TOOTH.raw$/i;
  const match = filePath.match(regex);
  if (match) {
    const stageNumber = parseInt(match[1], 10);
    const toothGumType = match[2];
    const toothMatrixList = await getRawDataFromToothMatrixRaw(fileData)
    return {
      toothGumType,
      stageNumber,
      toothMatrixList
    }
  }
  return null;
};
